/**
 *  @class
 *  @function CardProductImage
 */
if (!customElements.get('card-product-image')) {
  class CardProductImage extends HTMLElement {
    constructor() {
      super();

      this.sliderItems = this.querySelectorAll('.media-wrapper');
      if (!this.sliderItems.length == 1) return;
      this.classList.add('is-slider');
      
      this.prevButton = this.querySelector('button[name="previous"]');
      this.nextButton = this.querySelector('button[name="next"]');
      this.dots = this.querySelector('[id^="SliderDots-"]');

      theme.initWhenVisible({
        element: this,
        callback: this.init.bind(this),
        threshold: 200
      });
    }

    init() {
      const resizeObserver = new ResizeObserver(() => this.initPages());
      resizeObserver.observe(this);
  
      this.addEventListener('scroll', this.update.bind(this));
  
      if (this.nextButton) {
        this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
        this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
      }

      if (this.dots) {
        this.dots.addEventListener('click', this.onDotsClick.bind(this));
      }

      this.addEventListener('mouseenter', this.onHover.bind(this));
      this.addEventListener('mouseleave', this.onHoverOut.bind(this));
    }

    initPages() {
      this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
      if (this.sliderItemsToShow.length < 2) return;
      this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
      this.slidesPerPage = Math.floor(this.clientWidth / this.sliderItemOffset);
      this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
      this.update();
    }

    update() {
      const previousPage = this.currentPage;
      this.currentPage = Math.round(this.scrollLeft / this.sliderItemOffset) + 1;
  
      if (this.currentPage != previousPage) {
        this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
          currentPage: this.currentPage,
          currentElement: this.sliderItemsToShow[this.currentPage - 1]
        }}));
        if (this.dots) {
          this.dots.querySelectorAll('li').forEach(item => {
            item.classList.remove('current');
          })
          this.dots.querySelectorAll('li')[this.currentPage - 1].classList.add('current');
        }
      }
  
      if (this.currentPage === 1 && this.currentPage === this.totalPages) {
        this.classList.add('slider--no-buttons');
      } else {
        this.classList.remove('slider--no-buttons');
      }
    
      const isFirstSlide = this.currentPage === 1;
      const isLastSlide = this.currentPage === this.sliderItemsToShow.length;
  
      if (!this.nextButton) return;
  
      if (isFirstSlide || this.isSlideVisible(this.sliderItemsToShow[0])) {
        this.prevButton.setAttribute('disabled', 'disabled');
      } else {
        this.prevButton.removeAttribute('disabled');
      }
  
      if (isLastSlide || this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
        this.nextButton.setAttribute('disabled', 'disabled');
      } else {
        this.nextButton.removeAttribute('disabled');
      }
    }

    isSlideVisible(element, offset = 0) {
      const lastVisibleSlide = this.clientWidth + this.scrollLeft - offset;
      return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.scrollLeft;
    }

    onHover(e) {
      if (this.currentPage === 2 || !this.classList.contains('media--hover-effect')) return;
      e.preventDefault();
      const step = (2 > this.currentPage) ? 2 - this.currentPage : (this.currentPage - 2) * -1;
      this.goToSlide(step);
    }

    onHoverOut(e) {
      if (this.currentPage === 1) return;
      e.preventDefault();
      const step = (1 > this.currentPage) ? 1 - this.currentPage : (this.currentPage - 1) * -1;
      this.goToSlide(step);
    }

    onButtonClick(event) {
      event.preventDefault();
  
      if (event.currentTarget.name === 'next') {
        this.goToSlide(1);
      } else {
        this.goToSlide(-1);
      }
    }

    onDotsClick(event) {
      event.preventDefault();
      const li = event.target;
      const lis = Array.from(li.parentNode.children);
      const index = lis.indexOf(li) + 1;
  
      const step = (index > this.currentPage) ? index - this.currentPage : (this.currentPage - index) * -1;
      this.goToSlide(step);
    }

    goToSlide(step) {
      this.slideScrollPosition = this.scrollLeft + (step * this.sliderItemOffset);
      this.slideScrollPosition = theme.config.rtl ? this.slideScrollPosition * -1 : this.slideScrollPosition;
      this.scrollTo({
        left: this.slideScrollPosition
      });
    }
  }
  customElements.define('card-product-image', CardProductImage);
}